<div
    [class]="classes?.openViewWrapper"
    [style.background]="isFullPageImage ? backgroundUrl : themeColorCss(generalSettings.backgroundColor)"
    [class.mbViewWrapper]="isDeviceMobile$ | async"
>
    @if (isShowCatalogCard) {
        <div class="imageContainer row" [class.mbImageContainer]="isDeviceMobile$ | async">
            @if (element?.images?.length) {
                @if (!isFullPageImage) {
                    <web-gallery-views
                        [widgetId]="widgetId"
                        [data]="data"
                        [isDeviceMobile]="isDeviceMobile$ | async"
                    ></web-gallery-views>
                }
            } @else {
                <div class="blank-wrapper">
                    <img [src]="'./assets/img/websites/lpc-empty-product.png'" alt="product_blank" />
                </div>
            }
        </div>
        <div class="contentContainer" [class.mbContentContainer]="isDeviceMobile$ | async">
            <div class="contentWrapper" [class.mbContentWrapper]="isDeviceMobile$ | async">
                <div class="card-title sp-ui-text">
                    <h2>{{ element.name }}</h2>
                    <span class="card-article">
                        <small>{{ "widget_product_vendor_code" | translate }}: {{ this.element.vendorCode }}</small>
                    </span>
                </div>
                @if (element.price !== null) {
                    <div class="card-price-wrapper sp-ui-text">
                        <div class="card-price-block">
                            <p class="card-new-price">
                                {{ element.price | number: "1.2-2" }} {{ (shopSettings$ | async)?.currency }}
                            </p>
                            @if (element.oldPrice) {
                                <p class="card-old-price">
                                    {{ element.oldPrice | number: "1.2-2" }} {{ (shopSettings$ | async)?.currency }}
                                </p>
                            }
                        </div>
                        @if (isSubscriptionType) {
                            <p class="subscription-period mb-0">
                                (
                                {{
                                    "widget_product_subscription_period_text"
                                        | translate: { period: subscriptionPeriodKey | translate }
                                }}
                                )
                            </p>
                        }
                    </div>
                }
                <div class="variants-block sp-ui-text d-flex">
                    @for (property of element.properties; track property) {
                        <div>
                            <label>{{ property.name }}</label>
                            <select>
                                @for (option of property.parameters; track option) {
                                    <option>{{ option }}</option>
                                }
                            </select>
                        </div>
                    }
                </div>
                <div class="buttonWrapper">
                    <a [class]="getBasketButtonStyles" class="card-button">
                        {{ basketButton.label }}
                    </a>
                    <div class="card-product-counter">
                        <span class="counter-control">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                            >
                                <rect y="4" width="10" height="2" rx="1" fill="currentColor" />
                            </svg>
                        </span>
                        <span class="counter">1</span>
                        <span class="counter-control">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M4 9C4 9.55228 4.44772 10 5 10C5.55228 10 6 9.55228 6 9V6H9C9.55229 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4H6V1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447716 4 1V4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H4V9Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="card-description sp-ui-text">
                    <div [innerHTML]="element.shortDescription | spSafeHtml"></div>
                </div>
                @for (parameter of element.sections; track parameter) {
                    <div class="card-parameters sp-ui-text">
                        <label> {{ parameter.name }}</label>
                        @for (param of parameter.parameters; track param) {
                            <p>
                                <span class="param-prop"
                                    >{{ param.parameter }}
                                    @if (param.value) {
                                        <span>:</span>
                                    }
                                </span>
                                <span class="param-value">{{ param.value }}</span>
                            </p>
                        }
                    </div>
                }
                @if (element.dimensions) {
                    <div class="card-parameters sp-ui-text">
                        <label>{{ "widget_product_dimensions_title" | translate }}</label>
                        @if (element.dimensions.weight) {
                            <p>
                                <span class="param-prop">{{ "widget_product_dimensions_weight" | translate }}:</span>
                                <span class="param-value"
                                    >{{ element.dimensions.weight.value }}
                                    {{
                                        "widget_product_dimensions_unit_" + element.dimensions.weight.unit | translate
                                    }}</span
                                >
                            </p>
                        }
                        @if (element.dimensions.length) {
                            <p>
                                <span class="param-prop">{{ "widget_product_dimensions_length" | translate }}:</span>
                                <span class="param-value"
                                    >{{ element.dimensions.length }}
                                    {{ "widget_product_dimensions_unit_cm" | translate }}</span
                                >
                            </p>
                        }
                        @if (element.dimensions.width) {
                            <p>
                                <span class="param-prop">{{ "widget_product_dimensions_width" | translate }}:</span>
                                <span class="param-value"
                                    >{{ element.dimensions.width }}
                                    {{ "widget_product_dimensions_unit_cm" | translate }}</span
                                >
                            </p>
                        }
                        @if (element.dimensions.height) {
                            <p>
                                <span class="param-prop">{{ "widget_product_dimensions_height" | translate }}:</span>
                                <span class="param-value"
                                    >{{ element.dimensions.height }}
                                    {{ "widget_product_dimensions_unit_cm" | translate }}</span
                                >
                            </p>
                        }
                    </div>
                }
            </div>
        </div>
    } @else {
        <div class="hiddenCardContainer">
            <svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="0 0 180 180" fill="none">
                <path
                    d="M48 63C45.5147 63 43.5 65.0147 43.5 67.5V142.5C43.5 144.985 45.5147 147 48 147H132C134.485 147 136.5 144.985 136.5 142.5V67.5C136.5 65.0147 134.485 63 132 63H117.75V60H132C136.142 60 139.5 63.3579 139.5 67.5V142.5C139.5 146.642 136.142 150 132 150H48C43.8579 150 40.5 146.642 40.5 142.5V67.5C40.5 63.3579 43.8579 60 48 60H62.25V63H48Z"
                    fill="#7E8FA5"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M55.5 121.5C55.5 120.672 56.1716 120 57 120H85.5C86.3284 120 87 120.672 87 121.5C87 122.328 86.3284 123 85.5 123H57C56.1716 123 55.5 122.328 55.5 121.5ZM55.5 129C55.5 128.172 56.1716 127.5 57 127.5H73.5C74.3284 127.5 75 128.172 75 129C75 129.828 74.3284 130.5 73.5 130.5H57C56.1716 130.5 55.5 129.828 55.5 129Z"
                    fill="#7E8FA5"
                />
                <path
                    d="M105.38 76.8796C113.517 68.7423 113.858 55.7619 106.403 47.2179L75.7184 77.903C84.2624 85.3572 97.2422 85.017 105.38 76.8796ZM74.6204 46.1205C66.4831 54.2579 66.1429 67.2377 73.5971 75.7817L104.282 45.0966C95.7381 37.6424 82.7578 37.9831 74.6204 46.1205ZM107.501 79.001C97.8354 88.6664 82.1646 88.6664 72.4991 79.001C62.8336 69.3355 62.8336 53.6647 72.4991 43.9992C82.1646 34.3337 97.8354 34.3337 107.501 43.9992C117.166 53.6647 117.166 69.3355 107.501 79.001Z"
                    fill="#7E8FA5"
                />
            </svg>
            <p>{{ "hidden_catalog_product_noty" | translate }}</p>
        </div>
    }
</div>

@if (isShowCatalogCard) {
    <div [class]="classes?.fullDescription" class="sp-ui-text" [innerHTML]="element.description | spSafeHtml"></div>
}
